import type { FC, FormEvent, ReactNode } from 'react'

import { useState } from 'react'

type SubscribeFormProps = {
    buttonText?: string
    placeholder?: string
}

/**
 * Email capture form recreated from the Webflow w-form. Validates on the client
 * and shows the original success / error states. Not yet wired to a backend,
 * so submissions are acknowledged in the UI only.
 */
export const SubscribeForm: FC<SubscribeFormProps> = ({
    buttonText = 'Download Report',
    placeholder = 'Your Email'
}): ReactNode => {
    const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle')
    const [email, setEmail] = useState('')

    const onSubmit = (event: FormEvent<HTMLFormElement>): void => {
        event.preventDefault()
        const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
        setStatus(valid ? 'success' : 'error')
        if (valid) setEmail('')
    }

    return (
        <div className='subscribe-form w-form'>
            {status !== 'success' && (
                <form name='subscribe-form' className='subscribe-form-flex' onSubmit={onSubmit} noValidate>
                    <div className='subscribe-form-input-wrapper'>
                        <input
                            className='form-input subscribe-input w-input'
                            maxLength={256}
                            name='email'
                            placeholder={placeholder}
                            type='email'
                            value={email}
                            onChange={event => setEmail(event.target.value)}
                            aria-label='Email'
                            required
                        />
                    </div>
                    <input type='submit' className='button btn-subscribe w-button' value={buttonText} />
                </form>
            )}

            {status === 'success' && (
                <div className='success-message w-form-done' style={{ display: 'block' }}>
                    <div>Thank you! Your submission has been received!</div>
                </div>
            )}

            {status === 'error' && (
                <div className='error-message w-form-fail' style={{ display: 'block' }}>
                    <div>Oops! Please enter a valid email address.</div>
                </div>
            )}
        </div>
    )
}
